import { render, staticRenderFns } from "./ReporteHistoricoPremios.vue?vue&type=template&id=b59c719a&scoped=true"
import script from "./ReporteHistoricoPremios.vue?vue&type=script&lang=js"
export * from "./ReporteHistoricoPremios.vue?vue&type=script&lang=js"
import style0 from "./ReporteHistoricoPremios.vue?vue&type=style&index=0&id=b59c719a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59c719a",
  null
  
)

export default component.exports